<template>
  <router-view></router-view>
</template>

<script>
// import {useSystem} from "../store/system"
import debounce from 'lodash/debounce';
export default {
  name: 'App',
  components: {},
  mounted() {
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        // 使用 lodash.debounce 替代自定义 debounce
        callback = debounce(callback, 16); // 16ms 延迟
        super(callback);
      }
    };


    // const systemStore = useSystem()
    // if (window.screen.width <= 1000) {
    //   systemStore.setIsMobile(true)
    // }else{
    //   systemStore.setIsMobile(false)
    // }
    // window.addEventListener('resize', () => {
    //   console.log("窗口变化:", window.screen.width)
    //   if (window.screen.width <= 1000) {
    //     systemStore.setIsMobile(true)
    //   }else{
    //     systemStore.setIsMobile(false)
    //   }
    // })
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-button.is-loading:before{
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: none !important;
}
.el-button.is-loading:after{
  width: 100%;
  height: 100%;
  top: 0;
  rigth: 0;
  background: none !important;
}
.section__btn{
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
  height: 60px !important;
  border-radius: 10px !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  background: linear-gradient(135deg, #572c7c 0%, #572c7c 50%, #a034fa 100%) !important;
  color: #fff !important;
  text-transform: uppercase;
  font-weight: 500;
  position: relative;
}

.dialog-bg{
  background: $p-bg-linear-color !important;
  backdrop-filter: blur(10px) !important;
  border: 2px solid $p-border-color !important;
}

.el-overlay{
  background-color: $p-dialog-bg !important;
}

.card-bg{
  background: $p-bg-linear-color;
  border: 2px solid $p-border-color;
  color: $p-text-color;
  border-radius: 10px;

  &:hover, &:focus-within{
    background: $p-bg-linear-active-color;
  }
}

.card-bg-active{
  background: $p-bg-linear-active-color;
  border: 2px solid $p-border-color;
  color: $p-text-color;
  border-radius: 10px;

  &:hover, &:focus-within{
    background: $p-bg-linear-active-color;
  }
}

.card-white-bg-active{
  //background: $p-bg-blue-linear-active-color;
  background: $p-bg-white-linear-active-color;
  border: 2px solid $p-border-color;
  color: $p-text-color;
  border-radius: 10px;
}

.bottom-line{
  border-bottom: 2px solid $p-border-color;
}
</style>
